import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { allArticles } from "@/mocks/blog";

export default function AboutSection() {
  const topArticles = allArticles.slice(0, 3);

  return (
    <section className="relative w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-100">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
        {/* Left Text */}
        <div className="w-full lg:w-1/2">
          <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-3 py-1.5 rounded-full mb-5 whitespace-nowrap">
            Sobre Nós
          </span>

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            A Melhor<br />
            <span className="italic font-normal">Planilha</span><br />
            CSSBuy
          </h2>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-md">
            A <strong>CSSBuy Spreadsheet</strong> nasceu da necessidade de compradores brasileiros e portugueses que queriam produtos da China de qualidade, mas não sabiam por onde começar. Nossa planilha reúne os itens mais testados e populares, organizados por categoria, com links diretos e avaliações reais de qualidade.
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-md">
            Diferente de listas aleatórias em fóruns, cada produto da nossa <strong>planilha CSSBuy</strong> passa por verificação de qualidade, comparação de preço e teste de envio. Você economiza dinheiro, evita produtos ruins e compra com muito mais segurança.
          </p>
        </div>

        {/* Right Card - Navigation Links with Images */}
        <div className="w-full lg:w-1/2">
          <div className="bg-accent-800 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="flex items-center justify-between mb-8">
              <span className="text-accent-200/70 text-xs font-medium whitespace-nowrap">Navegue por Categoria</span>
              <div className="flex gap-1.5">
                <div className="w-2 h-2 rounded-full bg-accent-300/60"></div>
                <div className="w-2 h-2 rounded-full bg-accent-300/60"></div>
                <div className="w-2 h-2 rounded-full bg-accent-300/60"></div>
              </div>
            </div>

            {/* Category Nav Grid */}
            <div className="grid grid-cols-2 gap-3 mb-10">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 bg-accent-700/50 rounded-xl p-3 cursor-pointer transition-all hover:bg-accent-700/80 group"
                >
                  <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0">
                    <img src={cat.image} alt={cat.namePt} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="text-background-50 text-xs font-semibold whitespace-nowrap group-hover:text-accent-200 transition-colors">
                      {cat.namePt}
                    </p>
                    <p className="text-accent-200/60 text-xs whitespace-nowrap">{cat.count} itens</p>
                  </div>
                </a>
              ))}
            </div>

            <blockquote className="text-background-50 text-xl md:text-2xl lg:text-3xl font-heading italic leading-relaxed mb-8">
              "A <strong>planilha CSSBuy</strong> é uma lista organizada de produtos testados, ajudando compradores no Brasil e Portugal a economizar e comprar com segurança."
            </blockquote>

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-accent-600 flex items-center justify-center">
                  <i className="ri-team-line text-background-50 text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 text-sm font-semibold whitespace-nowrap">CSSBuy Team</p>
                  <p className="text-accent-200/70 text-xs whitespace-nowrap">Afiliado Oficial</p>
                </div>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1.5 bg-accent-200/20 text-background-50 text-xs font-medium px-4 py-2 rounded-full cursor-pointer transition-all hover:bg-accent-200/30 whitespace-nowrap"
              >
                Ver Planilha
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Article Quick Links Row */}
      <div className="mt-14 md:mt-20">
        <div className="flex items-center gap-3 mb-6">
          <i className="ri-article-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
          <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
            Guia de <span className="italic font-normal">Compras</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/50 cursor-pointer transition-all hover:border-accent-300 group"
            >
              <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover" />
              </div>
              <div>
                <span className="text-xs font-semibold text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">{article.category}</span>
                <p className="text-sm font-semibold text-foreground-900 mt-1.5 leading-snug group-hover:text-accent-700 transition-colors line-clamp-2">
                  {article.title}
                </p>
                <span className="text-xs text-foreground-400 mt-1 block whitespace-nowrap">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}